var _defs, _rect, _rect2, _g, _text, _text2, _text3, _text4, _text5, _text6, _g2, _text7, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContextSwitchingTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    width: 1200,
    height: 630,
    role: "img",
    "aria-label": "The context-switching tax: a fragmented workday of constant app toggling versus a consolidated day coordinated by the BossDrop AI layer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cstBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cstGlow",
    cx: 0.62,
    cy: 0.42,
    r: 0.68
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a4e6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cstAi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cstGold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cstRed",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f97316"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .h  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 800; fill: #f4f0fc; }\n      .s  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #b8b2cc; }\n      .eyebrow { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #cfc3ee; letter-spacing: 4px; }\n      .node { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #e2d9f5; }\n      .tiny { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #aaa4bd; letter-spacing: 2px; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#cstBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#cstGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90 H1200 M0 180 H1200 M0 270 H1200 M0 360 H1200 M0 450 H1200 M0 540 H1200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0 V630 M300 0 V630 M450 0 V630 M600 0 V630 M750 0 V630 M900 0 V630 M1050 0 V630"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 118,
    className: "eyebrow",
    fontSize: 20
  }, "THE CONTEXT-SWITCHING TAX")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 188,
    className: "h",
    fontSize: 60
  }, "1,200 toggles.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 254,
    className: "h",
    fontSize: 60
  }, "Four hours gone.")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 302,
    className: "s",
    fontSize: 24
  }, "Every week, per person.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 588,
    className: "s",
    fontSize: 20,
    opacity: 0.8
  }, "BOSSDROP.AI")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 368,
    className: "tiny",
    fontSize: 15
  }, "FRAGMENTED DAY")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 384,
    width: 430,
    height: 34,
    rx: 10,
    fill: "#1d1a2e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#cstRed)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 390,
    width: 16,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 390,
    width: 9,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 390,
    width: 21,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 390,
    width: 8,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 390,
    width: 13,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 390,
    width: 7,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 390,
    width: 18,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 390,
    width: 9,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 390,
    width: 12,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 390,
    width: 7,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 390,
    width: 20,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 390,
    width: 8,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 390,
    width: 14,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 390,
    width: 9,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 390,
    width: 17,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 390,
    width: 7,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 390,
    width: 12,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 390,
    width: 19,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 390,
    width: 8,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 390,
    width: 15,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 390,
    width: 8,
    height: 22,
    rx: 3
  })), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 444,
    className: "s",
    fontSize: 17
  }, "Slivers of attention between switches"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 490,
    className: "tiny",
    fontSize: 15
  }, "AGENT-ROUTED DAY")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 506,
    width: 430,
    height: 34,
    rx: 10,
    fill: "#1d1a2e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#cstAi)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 512,
    width: 128,
    height: 22,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 512,
    width: 96,
    height: 22,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 512,
    width: 168,
    height: 22,
    rx: 6
  })), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 566,
    className: "s",
    fontSize: 17
  }, "Whole blocks of usable focus"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1d1a2e",
    stroke: "#342e57",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 120,
    width: 86,
    height: 60,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 98,
    width: 86,
    height: 60,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 132,
    width: 86,
    height: 60,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 968,
    y: 104,
    width: 86,
    height: 60,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678,
    y: 212,
    width: 86,
    height: 60,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 216,
    width: 86,
    height: 60,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932,
    y: 200,
    width: 86,
    height: 60,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    className: "node",
    fontSize: 15,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 156
  }, "Chat"), /*#__PURE__*/React.createElement("text", {
    x: 779,
    y: 134
  }, "Tasks"), /*#__PURE__*/React.createElement("text", {
    x: 895,
    y: 168
  }, "Docs"), /*#__PURE__*/React.createElement("text", {
    x: 1011,
    y: 140
  }, "Email"), /*#__PURE__*/React.createElement("text", {
    x: 721,
    y: 248
  }, "Calendar"), /*#__PURE__*/React.createElement("text", {
    x: 849,
    y: 252
  }, "Tickets"), /*#__PURE__*/React.createElement("text", {
    x: 975,
    y: 236
  }, "CRM")), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#cstRed)",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.75,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M663 180 C 700 200, 740 170, 779 158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 158 C 830 190, 850 130, 895 192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 192 C 940 210, 970 150, 1011 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011 164 C 980 210, 780 200, 721 212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721 272 C 780 300, 800 250, 849 276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 276 C 900 300, 930 250, 975 260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663 180 C 640 240, 690 260, 721 212"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#cstAi)",
    strokeWidth: 3,
    fill: "none",
    opacity: 0.9,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721 272 C 760 330, 800 340, 840 372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 276 C 860 320, 862 340, 866 372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975 260 C 960 320, 930 340, 892 372"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 378,
    width: 470,
    height: 72,
    rx: 20,
    fill: "#171523",
    stroke: "url(#cstAi)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 414,
    r: 19,
    fill: "url(#cstGold)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661 414 l5 6 l11 -13",
    stroke: "#121020",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 702,
    y: 408,
    className: "h",
    fontSize: 22
  }, "BossDrop AI layer"), /*#__PURE__*/React.createElement("text", {
    x: 702,
    y: 434,
    className: "s",
    fontSize: 16
  }, "One context. One queue. One decision."), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M855 456 L855 492",
    stroke: "url(#cstAi)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846 484 L855 496 L864 484",
    stroke: "url(#cstAi)",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 502,
    width: 470,
    height: 60,
    rx: 18,
    fill: "#171523",
    stroke: "#342e57",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 855,
    y: 540,
    className: "node",
    fontSize: 20,
    textAnchor: "middle"
  }, "Fewer switches. More finished work.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextSwitchingTax);
export default __webpack_public_path__ + "static/media/context-switching-tax.3725bf3b4244ccdb7eafe0b0bc6b4212.svg";
export { ForwardRef as ReactComponent };